import { jwtDecode } from 'jwt-decode';

interface JwtTokenPayload {
  typ: string;
  cid: string;
  status: string;
  eoc: string;
  noc: string;
  cty: string;
  imei: string;
  type: string;
  exp: number;
  iat: number;
  iss: string;
  role?: string;
  role_ids?: string[];
}

export const decodeToken = (accessToken: string) => {
  let decoded: JwtTokenPayload | null = null;

  try {
    decoded = jwtDecode<JwtTokenPayload>(accessToken);
  } catch (error) {
    console.trace('Invalid jwt token', error);
  }

  return decoded;
};
